module.exports = __webpack_public_path__ + "static/media/2.56c1fc53.JPG";